import React, { useState, useEffect } from 'react'
import LoadingScreen from 'react-loading-screen'
import logo from "assets/img/logo/logo_aig_login-2.png";
import { Card, CardBody, Row, Col, Button, CardHeader, Label } from "reactstrap";
import { Textbox } from "react-inputs-validation";
import { Checkbox } from "react-inputs-validation";
const DatosEmpresa = ({ placa: placa1, handleNext,checkPlaca,setCheckPlaca,mostrarError,setMostrarError, datosProducto = {}, telefonoConductor = '' }) => {

    const [placa, setplaca] = useState(placa1)
    const [validate, setvalidate] = useState(false)

    useEffect(() => {
        setTimeout(() => setvalidate(true), 1000)
        window.scroll(0, 0)
        const { marcaCodigo, modeloCodigo } = datosProducto
        if (placa && !marcaCodigo && !modeloCodigo) {
            console.log('AAAAA', datosProducto)
            handleNext({ params: { placa }, paso: 1 });
        }

    }, [])

    const onClick = () => {
        setvalidate(true);
        const placa2 = placa.trim()

        if (placa2) {
            if (checkPlaca) {
                const paso = 1
                handleNext({ params: { placa: placa2 }, paso });
            } else {
                setMostrarError(true)
            }

        }
    }


    return (

        <Card >
            <CardHeader> <h4 style={{ fontWeight: 'bold', }}> Datos del Vehículo </h4></CardHeader>
            <CardBody>
                <Row className='mt-3'>
                    <Col sm={4} >
                        <h4 >Ingrese placa / RAMV</h4>
                    </Col>
                    <Col sm={7} >
                        <Textbox
                            type="text"
                            id="placa"
                            name="placa"
                            classNameInput={"form-control"}
                            value={placa}
                            validate={validate}
                            onChange={(placa, e) => setplaca(placa.toUpperCase())}
                            onBlur={() => { }}
                            validationCallback={res => { }}
                            validationOption={{
                                name: "placa", // Optional.[String].Default: "". To display in the Error message. i.e Please select a .
                                check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
                                required: true, // Optional.[Bool].Default: true. To determin if it is a required field.
                                //  reg: /^\d{13}$/,
                                msgOnError: "Por favor ingrese la placa del vehículo"
                            }}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col sm={4}>

                        <h4><Label for="checKCombustible" >El vehículo NO es utilizado para transporte de combustibles, tanqueros, crudo, sustancias peligrosas, maquinaria pesada, vehículos y transporte de personas.</Label></h4>

                    </Col>
                    <Col md={6} sm={12} xs={12} className="mb-3">
                        <Col md={12} sm={12} xs={12}>
                            <Checkbox
                                id={"checKCombustible"} // Optional.[String].Default: "".  Input ID.
                                name={"checKCombustible"} // Optional.[String].Default: "". Input name
                                value={checkPlaca} // Required.[String].Default: "".
                                onBlur={() => { }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                                checked={checkPlaca} // Required.[Bool].Default: false.
                                classNameInputBox={"check-uber"}
                                onChange={(checkPlaca, e) => {
                                    setCheckPlaca(checkPlaca)
                                    if(checkPlaca && mostrarError){
                                        setMostrarError(false)
                                    }
                                    //console.log(e);
                                }} // Required.[Func].Default: () => {}. Will return the value.
                            />
                            {mostrarError && (
                                <span style={{ color: "red", fontSize: "1rem" }}>
                                    Por favor marque esta opción para continuar
                                </span>
                            )}
                        </Col>
                    </Col>
                </Row>
                <Row>
                    <Col md={11} className="mt-3" >
                        <Button className="btn btn-primary " style={{ display: 'block', margin: '0 0 0 auto', }} onClick={() => onClick()}>
                            <i className="fa fa-chevron-circle-right" aria-hidden="true" />{` CONSULTAR`} {/* ${NumUbicacion} */}
                        </Button>
                    </Col>
                </Row>
            </CardBody>
        </Card>

    )

}
export default DatosEmpresa